/** Человекочитаемые метки для enum-значений в результатах шагов (SPEC §4.3). */
export const ENUM_LABELS: Record<string, string> = {
  enabled: "включён впервые",
  changed: "заменён",
  "no-member": "Нет аккаунта роли в чате",
  "launch-failed": "Не удалось запустить под-цепочку",
  unresolvable: "Чат не найден",
  "invite-unsupported": "Invite-ссылки не поддерживаются",
}

/** Префиксы подписей количества элементов для массивов (SPEC §4.2). */
export const ARRAY_CAPTION_PREFIXES: Record<string, string> = {
  dispatched: "заэнкьюено",
}
